import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const REACT_APP_ENVIRONMENT         = process.env.REACT_APP_ENVIRONMENT;
const REACT_APP_API_BASE_URL_LOCAL  = process.env.REACT_APP_API_BASE_URL_LOCAL;
const REACT_APP_API_BASE_URL_TEST   = process.env.REACT_APP_API_BASE_URL_TEST;
const REACT_APP_API_BASE_URL_LIVE   = process.env.REACT_APP_API_BASE_URL_LIVE;
let REACT_APP_API_BASE_URL          = '';

if( REACT_APP_ENVIRONMENT === 'LOCAL' ) {
  REACT_APP_API_BASE_URL = REACT_APP_API_BASE_URL_LOCAL;
} else if( REACT_APP_ENVIRONMENT === 'TEST' ) {
  REACT_APP_API_BASE_URL = REACT_APP_API_BASE_URL_TEST;
} else if( REACT_APP_ENVIRONMENT === 'LIVE' ) {
  REACT_APP_API_BASE_URL = REACT_APP_API_BASE_URL_LIVE;
}

export default REACT_APP_API_BASE_URL;

ReactDOM.render(
    <App />,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
